@if (isAssistantOpen()) {
<av-card [@slideFromRight]="true">
  <av-card-header (close)="dismiss()"></av-card-header>
  <av-card-body size="sm">
    @for (s of snapshots(); track trackByFn($index, s)) {
    <av-card-row>
      <av-vision [snapshot]="s"></av-vision>
    </av-card-row>
    }
  </av-card-body>
</av-card>
}
